// Menu trigger
(function() {
    // Two triggers, not one: Casper's burger lives inside .gh-head-brand
    // because its mobile menu hides .gh-head-actions entirely, so a trigger in
    // the actions row would vanish with it. The desktop dropdown needs one on
    // the right instead, so default.hbs renders a second button there and each
    // is shown at its own breakpoint. Both drive the same body class.
    // screen.css keeps nav items at opacity 0 above 992px until this class
    // appears:
    //   body:not(.is-dropdown-loaded) .gh-head-menu .nav > li { opacity: 0 }
    // Casper set it from dropdown.js once it had finished measuring overflow.
    // That script is gone (the burger replaces it), so the class has to be set
    // here or the menu opens empty.
    document.body.classList.add('is-dropdown-loaded');

    var burgers = document.querySelectorAll('.gh-burger');
    if (!burgers.length) return;

    var setState = function(isOpen) {
        burgers.forEach(function(b) {
            b.setAttribute('aria-expanded', String(isOpen));
        });
    };

    setState(false);

    burgers.forEach(function(burger) {
        burger.addEventListener('click', function(e) {
            e.stopPropagation();
            setState(document.body.classList.toggle('gh-head-open'));
        });
    });

    // Dismiss the desktop dropdown the way any menu should close: a click
    // outside it, or Escape. Casper never needed this because its mobile menu
    // covers the whole screen.
    document.addEventListener('click', function(e) {
        if (!document.body.classList.contains('gh-head-open')) return;
        if (e.target.closest('.gh-head-menu')) return;
        document.body.classList.remove('gh-head-open');
        setState(false);
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && document.body.classList.contains('gh-head-open')) {
            document.body.classList.remove('gh-head-open');
            setState(false);
        }
    });
})();
